import { defineComponent as _defineComponent } from 'vue'
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { onBeforeMount, ref, watch } from 'vue'
import { useAlert } from '@/v2/composables/alert/alert'
import { useAuthStore } from '@/store/pinia/auth'
import { useV2Api } from '@/plugins/api/openapi'
import { usePhysicianStore } from '@/store/pinia/physician'
import { ModalContent, ModalFooter, ModalHeader, ModalRoot } from '@/v2/components/ui/modal'
import TextInput from '../form/input/TextInput.vue'
import { extend } from 'vee-validate'
import AppButton from '@/v2/components/ui/button/AppButton.vue'
import { useApi } from '@/plugins/api'
import AppForm from '../form/AppForm.vue'
import LogosMap from '../logos/LogosMap.vue'
import { isCpfValid } from '@/plugins/validation'
import { useUtil } from '@/plugins/util'
import CertifiedViaSupport from './CertifiedViaSupport.vue'
import { computesRequired } from 'vee-validate/dist/types/rules/required'
import dayjs from 'dayjs'
import { APIError } from '@/plugins/api/error'


export default /*#__PURE__*/_defineComponent({
  __name: 'DigitalSignatureAuthModal',
  props: {
  value: { type: Boolean }
},
  emits: ["finish", "input"],
  setup(__props, { emit }) {


const util = useUtil()

const alert = useAlert()

const api = useApi()
const v2api = useV2Api()

const authStore = useAuthStore()
const physicianStore = usePhysicianStore()

const authData = ref<{
  cpf: string
  otp: string
}>({
  cpf: '',
  otp: '',
})

const invalidOtpError = ref<boolean>(false)

watch(
  () => authData.value.otp,
  (val) => {
    if (invalidOtpError.value) {
      invalidOtpError.value = false
    }
  },
)

onBeforeMount(async () => {
  const profile = physicianStore.physician

  if (profile?.cpf) {
    authData.value.cpf = profile.cpf
  }
})

extend('required_cpf', {
  validate: (value) => {
    return {
      required: true,
      valid: value && isCpfValid(value),
    }
  },
  computesRequired: true,
  message: 'Campo inválido. Tente novamente.',
})

extend('required_otp', {
  validate: (value) => {
    return {
      required: true,
      valid: util.toNumbersOnly(value).length === 6,
    }
  },
  computesRequired: true,

  message: ' Campo inválido. Tente novamente.',
})



const { modelValue } = __MACROS_useVModel(["modelValue", "value", "input"])

async function authenticateDigitalSignature() {
  try {
    const { token, expiresAt } = await v2api.birdId.generateToken({
      cpf: authData.value.cpf,
      otp: util.toNumbersOnly(authData.value.otp),
      physicianId: authStore.userId!,
    })

    emit('finish', token, dayjs(expiresAt).toDate())
    modelValue.value = false
  } catch (error) {
    if (error instanceof APIError && error.name === 'InvalidOtpException') {
      invalidOtpError.value = true
      return
    }
  }
}

const openCertifiedViaSuport = ref<boolean>(false)

return { __sfc: true,util, alert, api, v2api, authStore, physicianStore, authData, invalidOtpError, emit, modelValue, authenticateDigitalSignature, openCertifiedViaSuport, ModalContent, ModalFooter, ModalHeader, ModalRoot, TextInput, AppButton, AppForm, LogosMap, CertifiedViaSupport }
}

})